// Shared constants for device config settings
export const DEVICECONF_PLATFORM_OPTIONS = [
  {
    value: '',
    label: 'Autodetect',
    helpText: 'Attempt to autodetect platform. Requires NMS SNMP polling'
  },
  {
    value: 'arista-eos',
    label: 'Arista EOS'
  },
  {
    value: 'cisco-ios',
    label: 'Cisco IOS'
  },
  {
    value: 'cisco-ios-xe',
    label: 'Cisco IOS XE'
  },
  {
    value: 'cumulus-linux',
    label: 'Cumulus Linux (NVUE)'
  },
  {
    value: 'fortinet-fortios',
    label: 'Fortinet FortiOS'
  },
  {
    value: 'juniper-junos',
    label: 'Juniper Junos'
  },
  {
    value: 'nokia-srl',
    label: 'Nokia SR Linux'
  },
  {
    value: 'nokia-sros-classic',
    label: 'Nokia SR OS (Classic)'
  },
  // {
  //   value: 'nokia-sros',
  //   label: 'Nokia SR OS (MD-CLI)'
  // },
  {
    value: 'paloalto-panos',
    label: 'Palo Alto PAN-OS'
  }
];

export const DEVICECONF_FETCH_INTERVAL_OPTIONS = [
  {
    value: '',
    label: 'Disabled'
  },
  {
    value: '5m',
    label: '5 minutes'
  },
  {
    value: '10m',
    label: '10 minutes'
  },
  {
    value: '15m',
    label: '15 minutes'
  },
  {
    value: '30m',
    label: '30 minutes'
  },
  {
    value: '1h',
    label: 'Hourly'
  },
  {
    value: '6h',
    label: '6 hours'
  },
  {
    value: '12h',
    label: '12 hours'
  },
  {
    value: '24h',
    label: 'Daily'
  }
];

export const DEVICECONF_FETCH_TIMEOUT_OPTIONS = [
  {
    value: '30s',
    label: '30 seconds'
  },
  {
    value: '1m',
    label: '1 minute'
  },
  {
    value: '2m',
    label: '2 minutes'
  },
  {
    value: '5m',
    label: '5 minutes'
  },
  {
    value: '10m',
    label: '10 minutes'
  },
  {
    value: '15m',
    label: '15 minutes'
  },
  {
    value: '30m',
    label: '30 minutes'
  },
  {
    value: '1h',
    label: '1 hour'
  }
];
